module.exports = __webpack_public_path__ + "static/media/164-vietnam.da39c59f.svg";